<ng-container
  *ngIf="{
    off:
      controllers
      | findProperty : Property.isHvacRoomControlFancoilOff : updated : true,
    low:
      controllers
      | findProperty : Property.isHvacRoomControlFancoilLow : updated : true,
    medium:
      controllers
      | findProperty : Property.isHvacRoomControlFancoilMedium : updated : true,
    high:
      controllers
      | findProperty : Property.isHvacRoomControlFancoilHigh : updated : true,
    auto:
      controllers
      | findProperty : Property.isHvacRoomControlFancoilAuto : updated : true
  } as fancoilModes"
>
  <ng-container
    *ngIf="
      fancoilModes.off.length > 0 ||
      fancoilModes.low.length > 0 ||
      fancoilModes.medium.length > 0 ||
      fancoilModes.high.length > 0 ||
      fancoilModes.auto.length > 0
    "
  >
    <div
      class="status-container-small flex-row-center-v margin-bottom12 width230"
    >
      @if (fancoilModes.auto | propIsActive) {
      <div [ngClass]="icon" class="icon-background-on font-size19"></div>
      <div class="status-text-on">
        {{ text | translate }}: {{ "Auto" | translate }}
      </div>
      } @else if(FANCOIL_MODE_SHOW_STATUS_MANUAL && ((fancoilModes.low |
      propIsActive) || (fancoilModes.medium | propIsActive) ||
      (fancoilModes.high | propIsActive))) {
      <div [ngClass]="icon" class="icon-background-on font-size19"></div>
      <div class="status-text-on">
        {{ text | translate }}: {{ "Manual" | translate }}
      </div>
      } @else if(fancoilModes.high | propIsActive) {
      <div [ngClass]="icon" class="icon-background-on font-size19"></div>
      <div class="status-text-on">
        {{ text | translate }}: {{ "High" | translate }}
      </div>
      } @else if(fancoilModes.medium | propIsActive) {
      <div [ngClass]="icon" class="icon-background-on font-size19"></div>
      <div class="status-text-on">
        {{ text | translate }}: {{ "Medium" | translate }}
      </div>
      } @else if(fancoilModes.low | propIsActive) {
      <div [ngClass]="icon" class="icon-background-on font-size19"></div>
      <div class="status-text-on">
        {{ text | translate }}: {{ "Low" | translate }}
      </div>
      } @else if(fancoilModes.off | propIsActive) {
      <div [ngClass]="icon" class="icon-background-off font-size19"></div>
      <div class="status-text-off">
        {{ text | translate }}: {{ "Off" | translate }}
      </div>
      } @else {
      <div [ngClass]="icon" class="icon-background-off font-size19"></div>
      <div class="status-text-off">{{ text | translate }}:</div>
      }
    </div>
  </ng-container>
</ng-container>
